import { render } from "./BackButtonIcon.vue?vue&type=template&id=5cd21dac"
import script from "./BackButtonIcon.vue?vue&type=script&lang=js"
export * from "./BackButtonIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__